
import { Component } from '@angular/core';
import { GraphQLError } from 'graphql';
import { map } from 'rxjs';
import { CurrentUserQuery, DomainExportFieldGroupsGQL, DomainExportFieldGroupsQuery, DomainExportGQL, DomainFieldsFragment, DomainFilterContainer, DomainOrderBy, DomainOrderByKey, DomainsGQL, DomainsQuery } from 'src/app/graphql/gql';
import { DataMapperResult } from 'src/app/paginated-table/table-data-source';
import { COLUMN_DEFINITIONS } from './domain-column-defs';
import { FILTER_DEFINITIONS } from './domain-filter-defs';

@Component({
  selector: 'app-domains',
  templateUrl: './domains.component.html',
  styleUrls: ['./domains.component.css'],
  standalone: false
})
export class DomainsComponent {
  loading = true;
  data!: CurrentUserQuery;
  errors: readonly GraphQLError[] | undefined;

  selection: DomainFieldsFragment[] = []
  selectAll = false

  exportFieldGroupsDialogVisible = false
  exportFieldGroups: DomainExportFieldGroupsQuery['domainExportFieldGroups'] = [];
  selectedExportFields: string[] = [];

  displayedColumns: string[] = ['name', 'tld', 'state', 'brand'];

  columns = COLUMN_DEFINITIONS
  filters = FILTER_DEFINITIONS

  orderBy: { key: DomainOrderByKey; asc: boolean; } | null = null
  filterQueryParameter: DomainFilterContainer | null = null;

  constructor(
    public domainsGQL: DomainsGQL,
    public domainExportFieldGroups: DomainExportFieldGroupsGQL,
    public domainExport: DomainExportGQL
  ) {}

  dataMapper(data: DomainsQuery): DataMapperResult<DomainFieldsFragment> {
    return {
      items: data.domains!.edges!.map(edge => edge!.node!),
      totalCount: data.domains!.totalCount || null
    }
  }

  onDomainClick(domain: any) {
    console.log(domain)
  }

  onSelectionChange(selection: any[]) {
    this.selection = selection
  }

  onSelectAllChange(selectAll: boolean) {
    this.selectAll = selectAll
  }

  onOrderByChange(orderBy: { key: DomainOrderByKey; asc: boolean; } | null) {
    this.orderBy = orderBy
  }

  onFilterQueryParameterChange(filterQueryParameter: DomainFilterContainer | null) {
    this.filterQueryParameter = filterQueryParameter;
  }

  onExportClick() {
    this.domainExportFieldGroups.fetch().pipe(
      map(response => response.data.domainExportFieldGroups)
    ).subscribe(domainExportFieldGroups => {
      this.exportFieldGroups = domainExportFieldGroups;
      this.selectedExportFields = domainExportFieldGroups.flatMap(
        group => group.fields.filter(field => field.default).map(field => field.value)
      );
      this.exportFieldGroupsDialogVisible = true;
    });
  }

  onExportConfirm() {
    this.domainExport.fetch({
      ids: (this.selectAll || this.selection.length == 0) ? null : this.selection.map(o => o.id),
      fields: this.selectedExportFields,
      orderBy: this.orderBy,
      filter: this.filterQueryParameter
    }).subscribe({
      next: (response) => {
        const csvData = response.data.domainExport
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'domains_export.csv'
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
      }
    });
  }
}
